/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Privacy_TitleInputs */



/**
* | output |
* | --- |
* | "Privacy Policy" |
*
* @param {Legal_Privacy_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const legal_privacy_title = /** @type {((inputs?: Legal_Privacy_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Privacy_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Politique de confidentialité")
	if (locale === "es") return /** @type {LocalizedString} */ ("Política de privacidad")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Política de Privacidade")
	if (locale === "it") return /** @type {LocalizedString} */ ("Informativa sulla privacy")
	return /** @type {LocalizedString} */ ("Privacy Policy")
});